/* Mobile pilot: only these destinations navigate. Every other mobile
   link renders normally but shows a "Coming soon" toast on tap.
   Later PRs enable a screen by adding its path here. */

export const ENABLED_MOBILE_ROUTES = ['/dashboard/stats', '/dashboard/customers', '/dashboard/applications'];
